import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "ai_chat",
    component: () => import("@/views/AIChat/index.vue"),
  },
  {
    path: "/ai_write",
    name: "ai_write",
    component: () => import("@/views/AIWrite/index.vue"),
  },
  {
    path: "/ai_search",
    name: "ai_search",
    component: () => {
      return window.pcmjssdk ? import("@/views/AISearch/index.vue") : import("@/views/AISearch/AISearchHome/index.vue")
    }
  },
  {
    path: "/ai_search_detail",
    name: "ai_search_detail",
    meta: {
      title: '联想AI搜索'
    },
    component: () => { 
      return window.pcmjssdk ? import("@/views/AISearch/AISearchDetail/index.vue") : import("@/views/AISearch/AISearchDetail/indexV2.vue");
    },
  },
  {
    path: "/ai_write_result",
    name: "ai_write_result",
    component: () => import("@/views/AIWrite/result/index.vue"),
  },
  {
    path: "/ai_write_details",
    name: "ai_write_details",
    component: () => import("@/views/AIWrite/details"),
  },
  {
    path: "/ai_write_guide",
    name: "ai_write_guide",
    component: () => import("@/views/AIWrite/guide/index.vue"),
  },
  {
    path: "/ai_search_history",
    name: "ai_search_history",
    component: () => import("@/views/AISearch/AISearchHistory/index.vue"),
  },
  {
    path: "/ai_search_history_v2",
    name: "ai_search_history_v2",
    meta: {
      title: '联想AI搜索历史记录'
    },
    component: () => import("@/views/AISearch/AISearchHistoryBrowser/index.vue"),
  },
  // {
  //   path: "/ai_write_history",
  //   name: "aiWriteHistory",
  //   component: () => import("@/views/AIWrite/history/index.vue"),
  // },
  {
    path: "/game_box",
    name: "game_box",
    component: () => import("@/views/GameBox/index.vue"),
  },
  {
    path: "/game_box_search",
    name: "game_box_search",
    component: () => import("@/views/GameBox/search.vue"),
  },
  {
    path: "/ai_translate",
    name: "ai_translate",
    component: () => import("@/views/AITranslate/index.vue"),
  },
  {
    path: "/ai_translate_guide",
    name: "ai_translate_guide",
    component: () => import("@/views/AITranslate/guide/index.vue"),
  },
  {
    path: "/custom_add",
    name: "custom_add",
    component: () => import("@/views/CustomAdd/index.vue"),
  },
  {
    path: "/custom_add_guide",
    name: "custom_add_guide",
    component: () => import("@/views/CustomAdd/guide/index.vue"),
  },
  {
    path: "/doc_help",
    name: "doc_help",
    component: () => import("@/views/DocHelp/index.vue"),
  },
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  // base: process.env.BASE_URL,
  routes,
});

// 记录初始导航的路径
let initialNavigationPath = null;

router.beforeEach((to, from, next) => {
  // 记录首次导航的路径
  if (!initialNavigationPath) {
    initialNavigationPath = to.fullPath;
  }
  if(to.meta?.title){
    document.title = to.meta.title;
  }
  next();
});

// 监听路由导航失败
router.onError((error) => {
  // 检查是否是组件加载失败（资源加载错误）
  if (error.message.includes('Failed to fetch dynamically imported module') || 
      error.message.includes('Loading chunk')) {
    // 恢复地址栏URL为初始导航路径
    if (initialNavigationPath && window.location.pathname !== initialNavigationPath) {
      const newUrl = window.location.origin + initialNavigationPath + window.location.search;
      window.history.replaceState(null, '', newUrl);
    }
    
    // 可以在这里添加错误提示逻辑
    console.error('路由资源加载失败，已保持当前URL不变', error);
  }
});

export default router;